__turbopack_context__.v({
  "christmas": "logo-module-scss-module__-KfP8a__christmas",
  "index": "logo-module-scss-module__-KfP8a__index",
  "logo": "logo-module-scss-module__-KfP8a__logo",
  "logoIcon": "logo-module-scss-module__-KfP8a__logoIcon",
  "main": "logo-module-scss-module__-KfP8a__main",
  "right": "logo-module-scss-module__-KfP8a__right",
});
